import React from 'react';
import PageLayout from 'views/PageLayout.js';
import CoverageQuiz from 'views/CoverageQuiz.js';

// Shareable page version of the "Find Your Solution" quiz (same content as the
// on-site modal). Reachable directly at /build-your-system.
const BuildSystemPage = ({ products, onAddPackage }) => {
    return (
        <PageLayout
            eyebrow={'Find Your Solution'}
            title={'How many sensors do you need?'}
            subtitle={'Answer two quick questions and we’ll recommend the right coverage for your home.'}
            maxWidth={900}>
            <CoverageQuiz products={products} onAddPackage={onAddPackage} source={'page'} />
        </PageLayout>
    );
};

export default BuildSystemPage;
